import { TrendingUp, Lock, ArrowRight } from "lucide-react";
import { statusBand, CARD, TXT_PRIMARY, TXT_BODY, TXT_MUTED } from "@/lib/statusScale";

export function computeResilienceScore(readiness = {}) {
  const values = Object.values(readiness).filter((v) => typeof v === "number");
  if (!values.length) return 0;
  return Math.round(values.reduce((a, b) => a + b, 0) / values.length);
}

export default function ResilienceScore({ readiness, cta }) {
  const score = computeResilienceScore(readiness);
  const b = statusBand(score);
  return (
    <div
      data-testid="resilience-score"
      className={`rounded-xl border p-5 ${CARD}`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <TrendingUp className="h-4 w-4 text-teal-600 dark:text-teal-400" />
          <p className={`text-[11px] uppercase tracking-[0.14em] ${TXT_MUTED}`}>Resilience Score</p>
        </div>
        <span className={`text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full font-medium ${b.pill}`}>
          {b.label}
        </span>
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <span className={`font-display text-5xl font-semibold tabular-nums ${b.number}`}>{score}</span>
        <span className={`text-sm ${TXT_MUTED}`}>/ 100</span>
      </div>
      <p className={`mt-2 text-[12.5px] leading-relaxed ${TXT_BODY}`}>
        Composite of the five readiness indicators below. Track this quarter on quarter.
      </p>

      {cta?.primary && (
        <div className="mt-4 pt-4 border-t border-slate-200/70 dark:border-[#2A3438] space-y-2" data-testid="score-cta">
          <button
            onClick={cta.primary.onClick}
            data-testid={cta.primary.testid}
            className="w-full inline-flex items-center justify-center gap-2 min-h-[44px] px-4 rounded-md bg-slate-900 rs-cta-primary text-white text-sm font-semibold hover:bg-slate-800 transition-colors"
          >
            {cta.primary.icon === "lock" && <Lock className="h-4 w-4" />}
            {cta.primary.label}
            {cta.primary.icon === "arrow" && <ArrowRight className="h-4 w-4" />}
          </button>
          {cta.secondary && (
            <button
              onClick={cta.secondary.onClick}
              data-testid={cta.secondary.testid}
              className="w-full inline-flex items-center justify-center gap-2 min-h-[44px] px-4 rounded-md border border-teal-600 text-teal-700 dark:text-teal-300 dark:border-teal-500 text-sm font-medium hover:bg-teal-50 dark:hover:bg-teal-900/30 transition-colors"
            >
              {cta.secondary.label} <ArrowRight className="h-4 w-4" />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
